export default __webpack_public_path__ + "static/media/print_bill_lite.e5d03c24.svg";